import { useResponsesStore } from "../stores/Responses";
import { findResponse } from '../utils/FormFunctions';
import { appConfig } from "../../config/app_config";

export const isMobile = () => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < 768;
}

export const regionalise = (string) => {
    // check our region if it exists
    const region = findResponse(useResponsesStore.getState().responses, 'country');
    const voltage = region?.toLowerCase() === 'usa' ? '120' : '230';

    return string.toString().replaceAll('230', voltage);
}

// checks for any direct incoming URL args and saves them to local storage
export const checkForReferrer = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams = [
        'affiliate_code',
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_term',
        'utm_content',
        'gclid',
        'gbraid',
        'wbraid'
    ];

    utmParams.forEach((param) => {
        const value = urlParams.get(param);

        if (value) {
            // get ls object for utm params and save
            const ls = JSON.parse(localStorage.getItem('utm')) || {};

            ls[param] = {
                value: value,
                timestamp: Date.now()
            };

            localStorage.setItem('utm', JSON.stringify(ls));
        }
    });
}

// check for affiliate code and utms in local storage and save to responses
export const checkForSource = () => {
    const utmParams = [
        'affiliate_code',
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_term',
        'utm_content',
        'gclid',
        'gbraid',
        'wbraid'
    ];

    const ls_utm = localStorage.getItem('utm');

    if (ls_utm) {
        const utm = JSON.parse(ls_utm);

        utmParams.forEach((param) => {
            const p = utm[param];
            if (!p) return;

            if (param === 'affiliate_code' && p.timestamp) {
                const { maxAffiliateCodeValidDays } = appConfig;
                // check age of affiliate code is less than maxAffiliateCodeValidDays
                if (Date.now() - p.timestamp > maxAffiliateCodeValidDays * 24 * 60 * 60 * 1000) {
                    return;
                }
            }

            useResponsesStore.getState().addResponse({ id: param, value: p.value });
        });

        // if affiliate code is set, set utm_medium to "affiliate"
        if (utm.affiliate_code) {
            useResponsesStore.getState().addResponse({ id: 'utm_medium', value: 'affiliate' });
        }
    }
}

export const getEnvironmentFromHostname = () => {
    const hostname = window?.location?.hostname || '';

    if (hostname === 'nohma.com') return 'production';
    if (hostname.startsWith('dev.')) return 'development';
    if (hostname.startsWith('test.')) return 'testing';

    return 'unknown';
}